




























import Vue, { PropType } from 'vue';
import { Option } from 'mostra';
// import { Option } from '@/modules/options';

export default Vue.extend({
  name: 'GSelectContactButtonFormInput',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string>, required: true },
    // itemComment: { type: Array as PropType<string[]>, default: () => [] },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    name: { type: String as PropType<string> },
    selectedValue: { type: Number as PropType<number>, required: true },
    buttonOptions: { type: Array as PropType<Option[]>, default: () => [] },
  },
});
